module.exports = __webpack_public_path__ + "img/57.9.TU.60d281fb.png";